module.exports = __webpack_public_path__ + "static/portfolio_gallery_16-751d6628e564bea6957082aa67a137a7.jpg";